/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Type_Label_InlineInputs */



/**
* | output |
* | --- |
* | "Type:" |
*
* @param {Options_Metadata_Type_Label_InlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_type_label_inline = /** @type {((inputs?: Options_Metadata_Type_Label_InlineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Type_Label_InlineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Typ:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("类型：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイプ：")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकार:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo:")
	return /** @type {LocalizedString} */ ("Type:")
});